import { isArray } from "lodash";
import { avgWeight } from "../../pages/retirement_plan/functions/functionMain";
import { dataAgeAF } from "../../pages/retirement_plan/functions/functionRetriementPlan";
import { calDebtCreditCard } from "../../utils/useFunctions";
import { OutcomeChildEducation, OutcomeDebt } from "./retirementFunction";

export const OutcomeReliableCalAfter = (retireData, strategy) => {
  const straigyLists = strategy?.map((item) => item?.key);
  let tempOutcome = [];

  let ageRetire = retireData?.age_retire;

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  isArray(retireData?.af_plan_age) &&
    retireData?.af_plan_age?.map((item, indexA) => {
      let Outcome = retireData?.out_come * 12;

      if (item > ageRetire) {
        Outcome = Outcome * 0.7;
      }
      tempOutcome.push(Outcome);
    });

  return tempOutcome;
};

export const OutcomeReliableCalAfterNormal = (retireData, balanceData) => {
  let tempOutcome = [];

  // ========หนี้=============================

  // หนี้ดอกลอย
  let debtShortList = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_shortterm_other"
  )?.short_term_others;

  // หนี้ีนอกระบบ
  let debtInformalShortterm = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_informal_shortterm"
  )?.informal_short_terms;

  // เงินกู้ระยะสั้น
  let debtShortTerm = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_shortterm"
  )?.short_terms;

  // บัตรเครดิต
  let debtCreditcard = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_creditcard"
  )?.credit_cards;

  // ========หนี้ระยะยาว=============================

  // หนี้ระยะยาว รถ
  let debtCar = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_car"
  )?.debt_long_cars;

  // หนี้ระยะยาว บ้าน
  let debtPlace = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_place"
  )?.debt_long_places;

  // หนี้ระยะยาว อื่นๆ
  let debtLongOther = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_long_other"
  )?.debt_long_others;

  retireData?.af_plan_age?.map((item, indexA) => {
    tempOutcome.push(
      (retireData?.out_come - retireData?.strategy_out_come) * 12
    );

    // ========หนี้=============================

    // หนี้ดอกลอย
    debtShortList?.map((itemB, indexB) => {
      let year = Math.floor(itemB?.period / 12);
      let lastYearMonth = itemB?.period % 12;

      if (indexA >= Math.ceil(itemB?.period / 12)) {
        tempOutcome[indexA] += 0;
      }
      if (indexA < year) {
        tempOutcome[indexA] += itemB?.pay_permonth * 12;
      } else {
        tempOutcome[indexA] += itemB?.pay_permonth * lastYearMonth;
      }
    });

    // หนี้ีนอกระบบ
    debtInformalShortterm?.map((item2, index2) => {
      let year = Math.floor(item2?.number_of_days / 365);
      let lastYearMonth = item2?.number_of_days % 30;

      if (item2?.period === "Infinity") {
        tempOutcome[indexA] += item2?.pay_permonth * 12;
      } else {
        if (indexA >= Math.ceil(item2?.number_of_days / 365)) {
          tempOutcome[indexA] += 0;
        } else {
          if (indexA < year) {
            tempOutcome[indexA] += item2?.pay_permonth * 365;
          } else {
            tempOutcome[indexA] += item2?.pay_permonth * lastYearMonth;
          }
        }
      }
    });

    // เงินกู้ระยะสั้น
    debtShortTerm?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (item2?.period === "Infinity") {
        tempOutcome[indexA] += item2?.pay_permonth * 12;
      } else {
        if (indexA >= Math.ceil(item2?.number_of_days / 365)) {
          tempOutcome[indexA] += 0;
        } else {
          if (indexA >= Math.ceil(item2?.period / 12)) {
            tempOutcome[indexA] += 0;
          } else {
            if (indexA < year) {
              tempOutcome[indexA] += item2?.pay_permonth * 12;
            } else {
              tempOutcome[indexA] += item2?.pay_permonth * lastYearMonth;
            }
          }
        }
      }
    });

    // บัตรเครดิต
    debtCreditcard?.map((item2, index2) => {
      let period = calDebtCreditCard(item2)?.creditor_items?.length;
      let year = Math.floor(period / 12);
      let lastYearMonth = period % 12;

      if (item2?.type_payment === "pay_full" && indexA === 0) {
        return (tempOutcome[indexA] += item2?.pay_peryear);
      }

      if (indexA >= Math.ceil(period / 12)) {
        return (tempOutcome[indexA] += 0);
      }
      if (indexA < year) {
        return (tempOutcome[indexA] += item2?.pay_permonth * 12);
      } else {
        return (tempOutcome[indexA] += item2?.pay_permonth * lastYearMonth);
      }
    });

    // ========หนี้ระยะยาว=============================
    // หนี้ระยะยาว รถ
    debtCar?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (tempOutcome[indexA] += 0);
      }
      if (indexA < year) {
        return (tempOutcome[indexA] += item2?.pay_permonth * 12);
      } else {
        return (tempOutcome[indexA] += item2?.pay_permonth * lastYearMonth);
      }
    });

    // หนี้ระยะยาว บ้าน
    debtPlace?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (tempOutcome[indexA] += 0);
      }
      if (indexA < year) {
        return (tempOutcome[indexA] += item2?.pay_permonth * 12);
      } else {
        return (tempOutcome[indexA] += item2?.pay_permonth * lastYearMonth);
      }
    });

    // หนี้ระยะยาว อื่นๆ
    debtLongOther?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (tempOutcome[indexA] += 0);
      }
      if (indexA < year) {
        return (tempOutcome[indexA] += item2?.pay_permonth * 12);
      } else {
        return (tempOutcome[indexA] += item2?.pay_permonth * lastYearMonth);
      }
    });
  });

  return tempOutcome;
};

export const OutcomeUreliableCalAfter = (
  retireData,
  educationData,
  strategy
) => {
  const straigyLists = strategy?.map((item) => item?.key);

  let tempOutcome = [];

  let calPercent = retireData?.out_come_peryear;
  let ageRetire = retireData?.age_retire;
  let ageLength =
    Number(retireData?.age_dead) - Number(retireData?.age_current || 0) + 1;

  if (straigyLists?.includes("strategy_age_dead")) {
    ageLength =
      Number(retireData?.strategy_age_dead || retireData?.age_dead) -
      Number(retireData?.age_current || 0) +
      1;
  }

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_control_rate_outcome")
  ) {
    calPercent = avgWeight(
      Number(retireData?.investment_bf_retirement),
      Number(retireData?.investment_assets),
      Number(retireData?.strategy_assets_generate),
      Number(retireData?.strategy_assets_generate_per_year)
    );
  }

  if (straigyLists?.includes("strategy_control_rate_outcome")) {
    calPercent = strategy?.find(
      (item) => item?.key === "strategy_control_rate_outcome"
    )?.amount;
  }

  let stratigyAsset = Number(
    strategy?.find((item) => item?.key === "strategy_out_come")?.amount || 0
  );

  Array?.from({
    length: ageLength,
  })?.map((item, indexA) => {
    let calOutcome =
      Number(retireData?.out_come_variable - stratigyAsset || 0) *
      Math.pow(1 + calPercent / 100, indexA) *
      12;

    if (retireData?.af_plan_age[indexA] > ageRetire) {
      calOutcome = calOutcome * 0.7;
    }
    // tempOutcome.push(calOutcome * 12);
    tempOutcome.push(calOutcome);
  });

  return tempOutcome;
};

export const OutcomeUreliableCalAfterNormal = (retireData, age, strategy) => {
  const straigyLists = strategy?.map((item) => item?.key);

  let tempOutcome = [];

  let calPercent = retireData?.out_come_peryear;
  let ageRetire = retireData?.age_retire;
  let ageLength =
    Number(retireData?.age_dead) - Number(retireData?.age_current || 0) + 1;

  if (straigyLists?.includes("strategy_age_dead")) {
    ageLength =
      Number(retireData?.strategy_age_dead || retireData?.age_dead) -
      Number(retireData?.age_current || 0) +
      1;
  }

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_control_rate_outcome")
  ) {
    calPercent = avgWeight(
      Number(retireData?.investment_bf_retirement),
      Number(retireData?.investment_assets),
      Number(retireData?.strategy_assets_generate),
      Number(retireData?.strategy_assets_generate_per_year)
    );
  }

  if (straigyLists?.includes("strategy_control_rate_outcome")) {
    calPercent = strategy?.find(
      (item) => item?.key === "strategy_control_rate_outcome"
    )?.amount;
  }

  Array?.from({
    length: ageLength,
  })?.map((item, indexA) => {
    let calOutcome =
      (Number(retireData?.out_come || 0) -
        Number(retireData?.strategy_out_come || 0)) *
      Math.pow(1 + calPercent / 100, indexA) *
      12;
    if (indexA === 0) {
      calOutcome =
        (Number(retireData?.out_come || 0) -
          Number(retireData?.strategy_out_come || 0)) *
        Math.pow(1 + calPercent / 100, indexA) *
        12;
    }

    if (age > ageRetire) {
      calOutcome = calOutcome * 0.7;
    }

    tempOutcome.push(calOutcome);
  });

  return tempOutcome;
};

export const InvestmentReturnCalAfter = (
  retireData,
  strategy,
  balanceData,
  educationData
) => {
  const straigyLists = strategy?.map((item) => item?.key);
  let tempOutcomeReliable = OutcomeUreliableCalAfterNormal(retireData);
  let tempIncome = retireData?.af_plan_income;
  let tempOutcome = [];
  let valueInvest = {};

  let calPercent = avgWeight(
    Number(retireData?.investment_bf_retirement || 0),
    Number(retireData?.investment_assets || 0),
    Number(retireData?.strategy_assets_generate || 0),
    Number(retireData?.strategy_assets_generate_per_year || 0)
  );

  if (isNaN(calPercent)) {
    calPercent = retireData?.investment_bf_retirement || 0;
  }

  let retirePercent = retireData?.investment_af_retirement;
  let ageLength =
    Number(retireData?.age_dead) - Number(retireData?.age_current || 0) + 1;

  let ageRetire = retireData?.age_retire;

  if (straigyLists?.includes("strategy_investment_bf_retirement_change")) {
    calPercent = Number(
      retireData?.strategy_investment_bf_retirement_change || 0
    );
  }

  if (straigyLists?.includes("strategy_investment_af_retirement_change")) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (
    retireData?.strategy_investment_af_retirement_change >= 0 &&
    retireData?.strategy_investment_af_retirement_change &&
    straigyLists?.includes("strategy_investment_af_retirement_change")
  ) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (straigyLists?.includes("strategy_age_dead")) {
    ageLength =
      Number(retireData?.strategy_age_dead || retireData?.age_dead) -
      Number(retireData?.age_current || 0) +
      1;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_investment_af_retirement")
  ) {
    retirePercent = strategy?.find(
      (item) => item?.key === "strategy_investment_af_retirement"
    )?.amount;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_assets_generate_per_year")
  ) {
    calPercent = avgWeight(
      Number(retireData?.investment_bf_retirement || 0),
      Number(retireData?.investment_assets || 0),
      Number(retireData?.strategy_assets_generate || 0),
      Number(retireData?.strategy_assets_generate_per_year || 0)
    );
  }

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  let outcomeUreliableCalAfter = [
    ...OutcomeUreliableCalAfter(retireData, educationData, strategy),
  ];
  let outcomeReliableCalAfter = [
    ...OutcomeReliableCalAfter(retireData, strategy),
  ];
  let outcomeDebt = [...OutcomeDebt(retireData, balanceData, strategy)];

  let outcomeChildEducation = [
    ...OutcomeChildEducation(retireData, educationData),
  ];

  Array?.from(
    {
      length: ageLength,
    },
    () => 0
  )?.map((item, index) => {
    const valueInvest = {
      return_invest: 0,
      asset_invest: 0,
    };

    let totalRemain =
      Number(retireData?.af_plan_income_other?.[index] || 0) +
      Number(retireData?.af_plan_income?.[index] || 0) -
      (Number(outcomeUreliableCalAfter?.[index] || 0) +
        Number(outcomeReliableCalAfter?.[index] || 0) +
        Number(outcomeDebt?.[index] || 0) +
        (retireData?.ishavekids
          ? Number(outcomeChildEducation?.[index] || 0)
          : 0));

    if (index === 0) {
      valueInvest.return_invest =
        (Number(retireData?.investment_assets || 0) +
          Number(retireData?.strategy_assets_generate || 0)) *
        (Number(calPercent || 0) / 100);

      valueInvest.return_invest =
        valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

      valueInvest.asset_invest =
        Number(retireData?.investment_assets || 0) +
        Number(retireData?.strategy_assets_generate || 0) +
        Number(valueInvest.return_invest || 0) +
        totalRemain;
    } else {
      if (ageRetire < retireData?.af_plan_age[index]) {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number(retirePercent || 0) / 100);

        valueInvest.return_invest =
          valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

        valueInvest.asset_invest =
          Number(totalRemain || 0) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome[index - 1]?.asset_invest || 0);
      } else {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number(calPercent || 0) / 100);

        valueInvest.return_invest =
          valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

        valueInvest.asset_invest =
          Number(totalRemain || 0) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome[index - 1]?.asset_invest || 0);
      }
    }

    return tempOutcome.push(valueInvest);
  });

  return tempOutcome;
};

export const InvestmentReturnCalSensitive = (
  retireData,
  strategy,
  balanceData,
  educationData
) => {
  const straigyLists = strategy?.map((item) => item?.key);
  let tempOutcomeReliable = OutcomeUreliableCalAfterNormal(retireData);
  let tempIncome = retireData?.af_plan_income;
  let tempOutcome = [];
  let valueInvest = {};

  let calPercent = avgWeight(
    Number(retireData?.investment_bf_retirement || 0),
    Number(retireData?.investment_assets || 0),
    Number(retireData?.strategy_assets_generate || 0),
    Number(retireData?.strategy_assets_generate_per_year || 0)
  );

  let retirePercent = retireData?.investment_af_retirement;
  let ageLength =
    Number(retireData?.age_dead) - Number(retireData?.age_current || 0) + 1;

  let ageRetire = retireData?.age_retire;

  if (straigyLists?.includes("strategy_investment_bf_retirement_change")) {
    calPercent = Number(
      retireData?.strategy_investment_bf_retirement_change || 0
    );
  }

  if (straigyLists?.includes("strategy_investment_af_retirement_change")) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (
    retireData?.strategy_investment_af_retirement_change >= 0 &&
    retireData?.strategy_investment_af_retirement_change &&
    straigyLists?.includes("strategy_investment_af_retirement_change")
  ) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (straigyLists?.includes("strategy_age_dead")) {
    ageLength =
      Number(retireData?.strategy_age_dead || retireData?.age_dead) -
      Number(retireData?.age_current || 0) +
      1;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_investment_af_retirement")
  ) {
    retirePercent = strategy?.find(
      (item) => item?.key === "strategy_investment_af_retirement"
    )?.amount;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_assets_generate_per_year")
  ) {
    calPercent = avgWeight(
      Number(retireData?.investment_bf_retirement || 0),
      Number(retireData?.investment_assets || 0),
      Number(retireData?.strategy_assets_generate || 0),
      Number(retireData?.strategy_assets_generate_per_year || 0)
    );
  }

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  let outcomeUreliableCalAfter = [
    ...OutcomeUreliableCalAfter(retireData, strategy),
  ];
  let outcomeReliableCalAfter = [
    ...OutcomeReliableCalAfter(retireData, strategy),
  ];
  let outcomeDebt = [...OutcomeDebt(retireData, balanceData, strategy)];

  let outcomeChildEducation = [
    ...OutcomeChildEducation(retireData, educationData),
  ];

  Array?.from(
    {
      length: ageLength,
    },
    () => 0
  )?.map((item, index) => {
    const valueInvest = {
      return_invest: 0,
      asset_invest: 0,
    };

    let totalRemain =
      Number(retireData?.af_plan_income_other?.[index] || 0) +
      Number(retireData?.af_plan_income?.[index] || 0) -
      (Number(outcomeUreliableCalAfter?.[index] || 0) +
        Number(outcomeReliableCalAfter?.[index] || 0) +
        Number(outcomeDebt?.[index] || 0) +
        (retireData?.ishavekids
          ? Number(outcomeChildEducation?.[index] || 0)
          : 0));

    if (
      retireData?.check_imagine_two &&
      retireData?.age_current + index === retireData?.age_current + 5
    ) {
      totalRemain -= 1000000;
    }

    if (
      retireData?.check_imagine_three &&
      retireData?.age_current + index === retireData?.age_current + 10
    ) {
      totalRemain -= 5000000;
    }

    if (index === 0) {
      valueInvest.return_invest =
        (Number(retireData?.investment_assets || 0) +
          Number(retireData?.strategy_assets_generate || 0)) *
        (Number(calPercent || 0) / 100);

      valueInvest.asset_invest =
        Number(retireData?.investment_assets || 0) +
        Number(retireData?.strategy_assets_generate || 0) +
        Number(valueInvest.return_invest || 0) +
        totalRemain;
    } else {
      if (ageRetire < retireData?.af_plan_age[index]) {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number((retireData?.check_imagine_one ? 1 : retirePercent) || 0) /
            100);

        valueInvest.return_invest =
          valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

        valueInvest.asset_invest =
          Number(totalRemain || 0) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome[index - 1]?.asset_invest || 0);
      } else {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number(calPercent || 0) / 100);

        valueInvest.return_invest =
          valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

        valueInvest.asset_invest =
          Number(totalRemain || 0) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome[index - 1]?.asset_invest || 0);
      }
    }

    return tempOutcome.push(valueInvest);
  });

  return tempOutcome;
};

export const InvestmentReturnCalAfterNormal = (retireData, strategy) => {
  const tempStrategy = strategy || [];
  const straigyLists = tempStrategy?.map((item) => item?.key);

  let tempOutcomeReliable = OutcomeUreliableCalAfterNormal(retireData);
  let tempIncome = retireData?.af_plan_income;
  let tempOutcome = [];
  let valueInvest = {};

  // let calPercent = avgWeight(
  //   Number(retireData?.investment_bf_retirement || 0),
  //   Number(retireData?.investment_assets || 0),
  //   Number(retireData?.strategy_assets_generate || 0),
  //   Number(retireData?.strategy_assets_generate_per_year || 0)
  // );

  let calPercent = retireData?.investment_bf_retirement;

  let retirePercent = retireData?.investment_af_retirement;

  let ageLength =
    Number(retireData?.age_dead) - Number(retireData?.age_current || 0) + 1;

  let ageRetire = retireData?.age_retire;

  if (straigyLists?.includes("strategy_investment_bf_retirement_change")) {
    calPercent = Number(retireData?.strategy_investment_bf_retirement_change);
  }

  if (straigyLists?.includes("strategy_investment_af_retirement_change")) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (
    retireData?.strategy_investment_af_retirement_change >= 0 &&
    retireData?.strategy_investment_af_retirement_change &&
    straigyLists?.includes("strategy_investment_af_retirement_change")
  ) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (straigyLists?.includes("strategy_age_dead")) {
    ageLength =
      Number(retireData?.strategy_age_dead || retireData?.age_dead) -
      Number(retireData?.age_current || 0) +
      1;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_investment_af_retirement")
  ) {
    retirePercent = strategy?.find(
      (item) => item?.key === "strategy_investment_af_retirement"
    )?.amount;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_assets_generate_per_year")
  ) {
    calPercent = avgWeight(
      Number(retireData?.investment_bf_retirement),
      Number(retireData?.investment_assets),
      Number(retireData?.strategy_assets_generate),
      Number(retireData?.strategy_assets_generate_per_year)
    );
  }

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  Array?.from(
    {
      length: ageLength,
    },
    () => 0
  )?.map((item, index) => {
    const valueInvest = {
      return_invest: 0,
      asset_invest: 0,
    };

    if (index === 0) {
      valueInvest.return_invest =
        (Number(retireData?.investment_assets || 0) +
          Number(retireData?.strategy_assets_generate || 0)) *
        (Number(calPercent || 0) / 100);

      valueInvest.asset_invest =
        Number(tempIncome?.[index] || 0) +
        Number(retireData?.af_plan_income_other?.[index] || 0) -
        Number(
          OutcomeUreliableCalAfterNormal(
            retireData,
            dataAgeAF()?.[index],
            strategy
          )?.[index] || 0
        ) +
        Number(retireData?.investment_assets || 0) +
        Number(retireData?.strategy_assets_generate || 0) +
        Number(valueInvest?.return_invest || 0);
    } else {
      if (retireData?.af_plan_age?.[index] <= ageRetire) {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number(calPercent || 0) / 100);

        valueInvest.return_invest =
          valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

        valueInvest.asset_invest =
          Number(tempIncome?.[index] || 0) -
          Number(
            OutcomeUreliableCalAfterNormal(
              retireData,
              dataAgeAF()?.[index],
              strategy
            )?.[index] || 0
          ) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome?.[index - 1]?.asset_invest || 0);
      } else {
        valueInvest.return_invest =
          Number(tempOutcome?.[index - 1]?.asset_invest || 0) *
          (Number(retirePercent || 0) / 100);

        valueInvest.return_invest =
          valueInvest.return_invest < 0 ? 0 : valueInvest.return_invest;

        valueInvest.asset_invest =
          Number(tempIncome?.[index] || 0) -
          Number(
            OutcomeUreliableCalAfterNormal(
              retireData,
              dataAgeAF()?.[index],
              strategy
            )?.[index] || 0
          ) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome?.[index - 1]?.asset_invest || 0);
      }
    }

    return tempOutcome.push(valueInvest);
  });

  return tempOutcome;
};

export const InvestmentReturnCalSensitiveNormal = (retireData, strategy) => {
  const straigyLists = strategy?.map((item) => item?.key);
  let tempOutcomeReliable = OutcomeUreliableCalAfterNormal(retireData);
  let tempIncome = retireData?.af_plan_income;
  let tempOutcome = [];
  let valueInvest = {};

  let calPercent = avgWeight(
    Number(retireData?.investment_bf_retirement),
    Number(retireData?.investment_assets),
    Number(retireData?.strategy_assets_generate),
    Number(retireData?.strategy_assets_generate_per_year)
  );
  let retirePercent = retireData?.investment_af_retirement;

  let ageLength =
    Number(retireData?.age_dead) - Number(retireData?.age_current || 0) + 1;

  let ageRetire = retireData?.age_retire;

  if (straigyLists?.includes("strategy_investment_bf_retirement_change")) {
    calPercent = Number(retireData?.strategy_investment_bf_retirement_change);
  }

  if (straigyLists?.includes("strategy_investment_af_retirement_change")) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (
    retireData?.strategy_investment_af_retirement_change >= 0 &&
    retireData?.strategy_investment_af_retirement_change &&
    straigyLists?.includes("strategy_investment_af_retirement_change")
  ) {
    retirePercent = retireData?.strategy_investment_af_retirement_change;
  }

  if (straigyLists?.includes("strategy_age_dead")) {
    ageLength =
      Number(retireData?.strategy_age_dead || retireData?.age_dead) -
      Number(retireData?.age_current || 0) +
      1;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_investment_af_retirement")
  ) {
    retirePercent = strategy?.find(
      (item) => item?.key === "strategy_investment_af_retirement"
    )?.amount;
  }

  if (
    strategy
      ?.map((item) => item?.key)
      ?.includes("strategy_assets_generate_per_year")
  ) {
    calPercent = avgWeight(
      Number(retireData?.investment_bf_retirement),
      Number(retireData?.investment_assets),
      Number(retireData?.strategy_assets_generate),
      Number(retireData?.strategy_assets_generate_per_year)
    );
  }

  if (straigyLists?.includes("strategy_age_retire")) {
    ageRetire = retireData?.strategy_age_retire;
  }

  if (retireData?.check_imagine_one) {
    retirePercent = 1;
  }

  Array?.from(
    {
      length: ageLength,
    },
    () => 0
  )?.map((item, index) => {
    const valueInvest = {
      return_invest: 0,
      asset_invest: 0,
    };

    if (index === 0) {
      valueInvest.return_invest =
        (Number(retireData?.investment_assets || 0) +
          Number(retireData?.strategy_assets_generate || 0)) *
        (Number(calPercent || 0) / 100);

      valueInvest.asset_invest =
        Number(tempIncome[index] || 0) -
        Number(
          OutcomeUreliableCalAfterNormal(
            retireData,
            dataAgeAF()[index],
            strategy
          )[index] || 0
        ) +
        Number(retireData?.investment_assets || 0) +
        Number(retireData?.strategy_assets_generate || 0) +
        Number(valueInvest.return_invest || 0);
    } else {
      if (retireData?.af_plan_age[index] <= ageRetire) {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number(calPercent || 0) / 100);

        valueInvest.asset_invest =
          Number(tempIncome[index] || 0) -
          Number(
            OutcomeUreliableCalAfterNormal(
              retireData,
              dataAgeAF()[index],
              strategy
            )[index] || 0
          ) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome[index - 1]?.asset_invest || 0);
      } else {
        valueInvest.return_invest =
          Number(tempOutcome[index - 1]?.asset_invest || 0) *
          (Number(retirePercent || 0) / 100);

        valueInvest.asset_invest =
          Number(tempIncome[index] || 0) -
          Number(
            OutcomeUreliableCalAfterNormal(
              retireData,
              dataAgeAF()[index],
              strategy
            )[index] || 0
          ) +
          Number(valueInvest?.return_invest || 0) +
          Number(tempOutcome[index - 1]?.asset_invest || 0);
      }
    }

    return tempOutcome.push(valueInvest);
  });

  return tempOutcome;
};

export const DebtRetireAfter = (
  tempFutureData,
  balanceData,
  educationData,
  key_under_education
) => {
  let copytempFutureData = tempFutureData;

  let carExpense = tempFutureData?.expenese_car_items;
  let homeExpense = tempFutureData?.expenese_home_items;
  let childExpense = tempFutureData?.expenese_children_items;
  let travelExpense = tempFutureData?.expenese_travel_items;
  let collectionExpense = tempFutureData?.expenese_collection_items;
  let otherExpense = tempFutureData?.expenese_other_items;

  // =======รายรับ===========================

  //----------"มรดก"------------
  let incomeLegacyItems = tempFutureData?.income_legacy_items;
  //----------ขายธุรกิจ------------
  let incomeBusinessItems = tempFutureData?.income_business_items;

  //----------รายรับจากอสังหาริม------------
  let incomePropertyItems = tempFutureData?.income_property_items;

  //-------รายรับอื่นๆ----------
  let incomeOtherItems = tempFutureData?.income_other_items;

  // ========หนี้=============================

  // หนี้ดอกลอย
  let debtShortList = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_shortterm_other"
  )?.short_term_others;

  // หนี้ีนอกระบบ
  let debtInformalShortterm = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_informal_shortterm"
  )?.informal_short_terms;

  // เงินกู้ระยะสั้น
  let debtShortTerm = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_shortterm"
  )?.short_terms;

  // บัตรเครดิต
  let debtCreditcard = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_creditcard"
  )?.credit_cards;

  // ========หนี้ระยะยาว=============================

  // หนี้ระยะยาว รถ
  let debtCar = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_car"
  )?.debt_long_cars;

  // หนี้ระยะยาว บ้าน
  let debtPlace = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_place"
  )?.debt_long_places;

  // หนี้ระยะยาว อื่นๆ
  let debtLongOther = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_long_other"
  )?.debt_long_others;

  // คำนวณรายจ่าย
  let newTempData = tempFutureData?.cash_flow_items?.map((itemA, indexA) => {
    let newItem = itemA;

    newItem.outcome_total =
      Number(newItem?.out_come_stable || 0) +
      Number(newItem?.outcome_peryear || 0);

    carExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
      if (itemB?.year + itemB?.period_year > indexA && itemB?.year <= indexA) {
        newItem.outcome_total =
          itemB?.pay_per_year * 12 + newItem?.outcome_total;
      }
    });

    homeExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
      if (itemB?.year + itemB?.period_year > indexA && itemB?.year <= indexA) {
        newItem.outcome_total =
          itemB?.pay_per_year * 12 + newItem?.outcome_total;
      }
    });

    childExpense?.map((itemB, indexB) => {
      if (itemB?.ishasEducation) {
        if (itemB?.year > indexA) {
          return (newItem.outcome_total += itemB?.sum_invest_five);
        }

        // if (indexA > itemB?.year + 1 && indexA < itemB?.year + 21) {
        if (itemB?.year - 1 < indexA) {
          let eduExpense = Math.ceil(
            key_under_education?.[itemB?.education_under]?.default_value *
              Math.pow(1.06, indexA - 1)
          );
          return (newItem.outcome_total += eduExpense);
        }

        return (newItem.outcome_total += 0);
      }

      if (itemB?.year - 1 > indexA) {
        return (newItem.outcome_total += itemB?.sum_invest_five);
      }

      return (newItem.outcome_total += 0);
    });

    travelExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
    });

    collectionExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
    });

    otherExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
    });

    //----------"การศึกษาบุตร"------------

    educationData?.map((itemB, indexB) => {
      if (tempFutureData?.expenese_children_education?.length > 0) {
        newItem.outcome_total += Number(
          itemB?.education_items[indexA]?.sum_under_education || 0
        );

        return;
      }
    });

    // ========หนี้=============================

    // หนี้ดอกลอย
    debtShortList?.map((itemB, indexB) => {
      let year = Math.floor(itemB?.period / 12);
      let lastYearMonth = itemB?.period % 12;

      if (indexA >= Math.ceil(itemB?.period / 12)) {
        newItem.outcome_total += 0;
      }
      if (indexA < year) {
        newItem.outcome_total += itemB?.pay_permonth * 12;
      } else {
        newItem.outcome_total += itemB?.pay_permonth * lastYearMonth;
      }
    });

    // หนี้ีนอกระบบ
    debtInformalShortterm?.map((item2, index2) => {
      let year = Math.floor(item2?.number_of_days / 365);
      let lastYearMonth = item2?.number_of_days % 30;

      if (item2?.period === "Infinity") {
        newItem.outcome_total += item2?.pay_permonth * 12;
      } else {
        if (indexA >= Math.ceil(item2?.number_of_days / 365)) {
          newItem.outcome_total += 0;
        } else {
          if (indexA < year) {
            newItem.outcome_total += item2?.pay_permonth * 365;
          } else {
            newItem.outcome_total += item2?.pay_permonth * lastYearMonth;
          }
        }
      }
    });

    // เงินกู้ระยะสั้น
    debtShortTerm?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (item2?.period === "Infinity") {
        newItem.outcome_total += item2?.pay_permonth * 12;
      } else {
        if (indexA >= Math.ceil(item2?.number_of_days / 365)) {
          newItem.outcome_total += 0;
        } else {
          if (indexA >= Math.ceil(item2?.period / 12)) {
            newItem.outcome_total += 0;
          } else {
            if (indexA < year) {
              newItem.outcome_total += item2?.pay_permonth * 12;
            } else {
              newItem.outcome_total += item2?.pay_permonth * lastYearMonth;
            }
          }
        }
      }
    });

    // บัตรเครดิต
    debtCreditcard?.map((item2, index2) => {
      let period = calDebtCreditCard(item2)?.creditor_items?.length;
      let year = Math.floor(period / 12);
      let lastYearMonth = period % 12;

      if (item2?.type_payment === "pay_full" && indexA === 0) {
        return (newItem.outcome_total += item2?.pay_peryear);
      }

      if (indexA >= Math.ceil(period / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    // ========หนี้ระยะยาว=============================

    // หนี้ระยะยาว รถ
    debtCar?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    // หนี้ระยะยาว บ้าน
    debtPlace?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    // หนี้ระยะยาว อื่นๆ
    debtLongOther?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    return newItem;
  });

  // คำนวณรายรับ
  newTempData?.map((itemA, indexA) => {
    let newItem = itemA;
    // newItem.income_peryear = 0

    if (itemA?.age > tempFutureData?.age_retire) {
      newItem.income_peryear = itemA?.pension_peryear;
    }

    //----------"มรดก"------------
    incomeLegacyItems?.map((itemB, indexB) => {
      if (itemB?.year === indexA) {
        return (newItem.income_peryear += itemB?.amount);
      }
    });

    //----------ขายธุรกิจ------------
    incomeBusinessItems?.map((itemB, indexB) => {
      if (itemB?.year === indexA) {
        return (newItem.income_peryear += itemB?.amount);
      }
    });

    //----------รายรับจากอสังหาริม------------
    incomePropertyItems?.map((itemB, indexB) => {
      if (itemB?.is_rent) {
        if (itemB?.year > indexA) {
          return (newItem.income_peryear += 0);
        }
        if (itemB?.year <= indexA && itemB?.year + itemB?.year_rent > indexA) {
          return (newItem.income_peryear += itemB?.amount_perYear);
        }
        return (newItem.income_peryear += 0);
      }

      if (itemB?.year === indexA) {
        return (newItem.income_peryear += itemB?.amount);
      }
    });

    //-------รายรับอื่นๆ----------
    incomeOtherItems?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        return (newItem.income_peryear += 0);
      }
      if (itemB?.year <= indexA && itemB?.year + itemB?.year_rent > indexA) {
        return (newItem.income_peryear += itemB?.amount_perYear);
      }
      return (newItem.income_peryear += 0);
    });

    return newItem;
  });

  // คำนวณคงเหลือ
  newTempData?.map((itemA, indexA) => {
    let newItem = itemA;
    newItem.remain =
      Number(itemA?.income_peryear || 0) - Number(itemA?.outcome_total || 0);

    return newItem;
  });

  // ผลตอบแทนการลงทุน
  // สินทรัพย์ลงทุน

  newTempData?.map((itemA, indexA) => {
    let newItem = itemA;
    if (indexA === 0) {
      newItem.income_investment =
        (tempFutureData?.income_investment *
          tempFutureData?.income_investment_percent) /
        100;
      newItem.remain_accumulate =
        Number(newItem?.remain || 0) +
        Number(newItem?.income_investment || 0) +
        Number(tempFutureData?.income_investment || 0);

      return newItem;
    }
    // newItem.income_investment = (newTempData[indexA-1]* tempFutureData?.income_investment_percent)/100
    newItem.remain_accumulate =
      Number(newItem?.remain || 0) +
      Number(newItem?.income_investment || 0) +
      Number(newTempData[indexA - 1]?.remain_accumulate || 0);

    return newItem;
  });

  return newTempData;
};
